/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable max-len */
/* eslint-disable no-alert */
/* eslint-disable no-nested-ternary */
import { Loading } from '@brands/Components/LoadingSpinner/Loading';
import PatientIntakeNavigation from '@brands/Components/PatientIntakeNavigation/PatientIntakeNavigation';
import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import useSubscribe, { Subscriber } from '@brands/hooks/useSubscribe';
import { setUserWebState } from '@brands/services/auth/setUserWebState';
import { selectAuth } from '@brands/store/selectors/auth';
import { selectCurrentPatientState } from '@brands/store/selectors/currentPatientState';
import { selectOrganization } from '@brands/store/selectors/organization';
import { selectOrganizationPrices } from '@brands/store/selectors/organizationPrices';
import { selectPatientForm } from '@brands/store/selectors/patientForm';
import { selectPatient } from '@brands/store/selectors/selectedPatient';
import { setForm } from '@brands/store/slices/patientFormSlice';
import store from '@brands/store/store';
import { displayErrorDetails } from '@brands/Utils/displayError';
import {
  getPatientReviewProfileRoleSegment,
  getStaffReviewProfileBasePath,
  isStaffCaseCreationRole,
} from '@brands/Utils/reviewProfileBasePath';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Button } from '@mui/material';
import Cookies from 'js-cookie';
import queryString from 'query-string';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import QRCode from 'react-qr-code';
import { useLocation, useNavigate } from 'react-router-dom';

import Container from '../../../../Components/Container/Container';
import { useAppDispatch, useAppSelector } from '../../../../hooks/useReduxHook';
import useWindowSize from '../../../../hooks/useWindowSize';
import MobileHandoffModal from './Components/MobileHandoffModal';
import firstImage from './Components/QRLearnMoreImages/1.svg';
import seconfImage from './Components/QRLearnMoreImages/2.svg';
import thirdImage from './Components/QRLearnMoreImages/3.svg';
import fourthImage from './Components/QRLearnMoreImages/4.svg';
import styles from './styles.module.scss';

const QRLearnMore = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const roleNavigate = useRoleNavigate();
  const screenSize = useWindowSize();
  const { state, search } = useLocation();
  const { userInfo } = useAppSelector(selectAuth);
  const { currentOrganization } = useAppSelector(selectOrganization);
  const { currentOrganizationPrices } = useAppSelector(selectOrganizationPrices);
  const [useintraoralCamera, setUseIntraoralCamera] = useState(false);
  const [loading, setLoading] = useState(false);
  const [displayMobileHandOffModal, setDisplayMobileHandOffModal] = useState(false);
  const queryParams = useMemo(() => queryString.parse(search), [search]);
  const { values } = useAppSelector(selectPatientForm);
  const { selectedPatient: currentPatient } = useAppSelector(selectPatient);
  const currentState: Record<number, string> = useAppSelector(selectCurrentPatientState);
  const [selectedDeviceId, setSelectedDeviceId] = useState<string | null>(null);
  const videoRef = useRef<HTMLVideoElement>(null);

  const [newUrl, setNewUrl] = useState('');

  useEffect(() => {
    navigator.mediaDevices.enumerateDevices().then((devices) => {
      const videoDevices = devices.filter((d) => d.kind === 'videoinput');
      if (videoDevices.length > 0) setSelectedDeviceId(videoDevices[0].deviceId);
    });
  }, []);

  const subscriber: Subscriber = useMemo(
    () => ({
      onMessage: (message: Record<string, any>) => {
        if (['mobile_handoff'].includes(message.command)) {
          setDisplayMobileHandOffModal(true);
        } else if (['mobile_case_creation_complete'].includes(message.command)) {
          setDisplayMobileHandOffModal(false);
          goToDashboard();
        }
      },
      commands: ['mobile_handoff', 'mobile_case_creation_complete'],
    }),
    [setDisplayMobileHandOffModal],
  );
  const { subscribe, unsubscribe } = useSubscribe();

  useEffect(() => {
    const subscriptionId = subscribe(subscriber);

    return () => unsubscribe(subscriptionId);
  }, [subscribe, unsubscribe, subscriber]);

  const appendStateToUrl = (jwtToken: string): string => {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);

    // Set the 'auth' parameter with the JWT token
    url.searchParams.set('auth', encodeURIComponent(jwtToken));

    return url.toString();
  };

  const goToDashboard = useCallback(() => {
    const patientId = (state as { patientId?: number } | null)?.patientId;
    if (isStaffCaseCreationRole(userInfo.role.name) && patientId != null) {
      navigate(
        `${getStaffReviewProfileBasePath(userInfo.role.name)}/${getPatientReviewProfileRoleSegment(
          currentPatient,
        )}/${patientId}`,
      );
    } else {
      roleNavigate('/dashboard');
    }
  }, [userInfo.role.name, navigate, roleNavigate, state, currentPatient]);

  useEffect(() => {
    const fetchDataAndSetState = async (): Promise<void> => {
      setLoading(true);
      if (!queryParams.state) {
        // Retrieve and compress the Redux state
        const reduxState = store.getState();

        // Extract only the needed parts
        const { auth, pageState } = reduxState;

        // Create a new object with the selected parts
        const selectedState = {
          auth,
          patientForm: reduxState.patientForm,
          selectedPatient: currentPatient,
          pageState,
          patientcurrentOrganization: currentOrganization,
          patientcurrentOrganizationPrices: currentOrganizationPrices,
          refreshToken: Cookies.get('refreshToken'),
          jwtTokenExpire: Cookies.get('jwtTokenExpire'),
          patientState: userInfo.id in currentState ? { [userInfo.id]: currentState[userInfo.id] } : {},
        };

        // Set User Web State
        try {
          await setUserWebState(selectedState);
        } catch (error: unknown) {
          displayErrorDetails(error);
        }

        setNewUrl(appendStateToUrl(Cookies.get('jwtToken') as string));
        setLoading(false);
      }
    };
    if (queryParams.auth === undefined) {
      fetchDataAndSetState();
    }
  }, [queryParams]);

  useEffect(() => {
    if (useintraoralCamera) {
      if (!selectedDeviceId) return;

      navigator.mediaDevices.getUserMedia({ video: { deviceId: { exact: selectedDeviceId } } }).then((stream) => {
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
        }
      });

      return () => {
        if (videoRef.current?.srcObject instanceof MediaStream) {
          videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
        }
      };
    }
  }, [selectedDeviceId, useintraoralCamera]);

  const onBack = (): void => {
    if (useintraoralCamera) {
      const videoElement = document.querySelector('video');
      const stream = videoElement?.srcObject as MediaStream | null;

      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
      }
      setUseIntraoralCamera(false);
    } else {
      dispatch(setForm([...values!]));
      navigate(-1);
    }
  };

  if (loading) {
    return <Loading fullScreen />;
  }

  return (
    <Container
      isVisibleOnMobile
      containerStyle={{
        justifyContent: screenSize.width >= 564 ? 'center' : 'start',
        overflow: 'hidden',
      }}
      childrenStyle={{ zIndex: '2', paddingTop: screenSize.width > 768 ? '40px' : '16px' }}
      isSidenavVisible={false}
      isIntakeProcess
    >
      <div className={styles.uploadImageContainer}>
        <div className={styles.patientSelectTopDivContainer}>
          <PatientIntakeNavigation progress={68} />
        </div>
        <div className={styles.uploadImageContainerDiv}>
          <div className={styles.uploadImageContainerDivFirst}>
            <div className={styles.qrLearnMoreHeaderDiv} data-testid="qr-learn-more-header">
              <span className={styles.qrLearnMoreHeader}>How to scan a QR code</span>
              <span className={styles.qrLearnMoreHeaderSub}>
                Here’s a quick 4 step process on how to scan a QR code to use our guided image capture.
              </span>
            </div>
          </div>
          <div className={styles.qrLearnMoreContentDiv}>
            <div className={styles.qrLearnMoreContent}>
              <div className={styles.qrLearnMoreContentFrame}>
                <span className={styles.qrLearnMoreContentFrameNumber}>
                  <span>1</span>
                </span>
                <span className={styles.qrLearnMoreContentFrameText}>Point your smartphone camera at the QR code</span>
              </div>
              <div className={styles.qrLearnMoreContentGroup}>
                <img src={firstImage} alt="First Image" />
              </div>
            </div>
            <div className={styles.qrLearnMoreContent}>
              <div className={styles.qrLearnMoreContentGroup}>
                <img src={seconfImage} alt="Second Image" />
              </div>
              <div className={styles.qrLearnMoreContentFrame}>
                <span className={styles.qrLearnMoreContentFrameNumber}>
                  <span>2</span>
                </span>
                <span className={styles.qrLearnMoreContentFrameText}>
                  Wait for your camera to recognize the QR code
                </span>
              </div>
            </div>
            <div className={styles.qrLearnMoreContent}>
              <div className={styles.qrLearnMoreContentFrame}>
                <span className={styles.qrLearnMoreContentFrameNumber}>
                  <span>3</span>
                </span>
                <span className={styles.qrLearnMoreContentFrameText}>
                  Click the banner or notification when it appears on your screen
                </span>
              </div>
              <div className={styles.qrLearnMoreContentGroup}>
                <img src={thirdImage} alt="Third Image" />
              </div>
            </div>
            <div className={styles.qrLearnMoreContent}>
              <div className={styles.qrLearnMoreContentGroup}>
                <img src={fourthImage} alt="Fourth Image" />
              </div>
              <div className={styles.qrLearnMoreContentFrame}>
                <span className={styles.qrLearnMoreContentFrameNumber}>
                  <span>4</span>
                </span>
                <span className={styles.qrLearnMoreContentFrameText}>
                  You’ll be brought directly to the guided image capture
                </span>
              </div>
            </div>
            <div className={styles.qrLearnMoreContent}>
              <div className={styles.qrLearnMoreContentFinalLeft}>
                <span>Go ahead and give it a try!</span>
                <Button variant="text" onClick={() => roleNavigate('/upload-image-flow')}>
                  Or, Upload photos manually
                </Button>
              </div>
              <div className={styles.qrLearnMoreContentFinalRight}>
                <span>
                  <QRCode value={newUrl} size={150} />
                </span>
              </div>
            </div>
          </div>
          <div className={styles.uploadImageContainerDivFooter}>
            <Button onClick={onBack} className={styles.backBtn}>
              <ArrowBackIosIcon />
              Back
            </Button>
          </div>
        </div>

        {displayMobileHandOffModal && <MobileHandoffModal />}
      </div>
    </Container>
  );
};
export default QRLearnMore;
